import Add from "@mui/icons-material/Add";
import Remove from "@mui/icons-material/Remove";
import { IconButton, Stack, Typography } from "@mui/material";

import { ListItem } from "../ListItem";
import { EnhancedOption } from "./types"; // Ensure this includes the alwaysOpen boolean

interface OptionRenderProps {
  option: EnhancedOption;
  expandedItems: number[];
  toggleExpand: (id: number) => void;
}

const BUTTON_WIDTH = 30;
const BUTTON_HEIGHT = 30;

const HierarchicalRenderOption: React.FC<OptionRenderProps> = ({
  option,
  expandedItems,
  toggleExpand,
  ...props
}) => {
  // Consider the item as expanded if it's in the expandedItems array or if alwaysOpen is true
  const isExpanded = expandedItems.includes(option.id) || option.alwaysOpen;
  const marginLeft =
    8 * option.depth + (option.hasChildren || option.alwaysOpen ? 0 : BUTTON_WIDTH);
  const fontWeight = isExpanded && option.hasChildren && !option.alwaysOpen ? 600 : 400;

  // Style non-selectable options
  const isNonSelectable = option.selectable === false;
  const textColor = isNonSelectable ? "text.disabled" : "text.primary";
  const opacity = isNonSelectable ? 0.6 : 1;

  const handleIconClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation(); // Prevents the autocomplete from selecting the item
    if (option.hasChildren && !option.alwaysOpen) {
      toggleExpand(option.id);
    }
  };

  return (
    <ListItem {...props} sx={{ opacity }}>
      <Stack
        marginLeft={marginLeft + "px"}
        direction={"row"}
        alignItems={"center"}
        spacing={1}
        justifyContent="space-between"
        sx={{ width: "100%" }}
      >
        <Stack direction={"row"} alignItems={"center"} spacing={1}>
          {option.hasChildren && !option.alwaysOpen && (
            <IconButton
              onClick={handleIconClick}
              size="small"
              sx={{
                width: BUTTON_WIDTH,
                height: BUTTON_HEIGHT,
              }}
            >
              {isExpanded ? <Remove /> : <Add />}
            </IconButton>
          )}
          <Typography
            sx={{
              maxWidth: "240px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: textColor,
            }}
            fontWeight={fontWeight}
          >
            {option.label}
          </Typography>
        </Stack>
        {option.endAdornment && option.endAdornment}
      </Stack>
    </ListItem>
  );
};

export default HierarchicalRenderOption;
